import React, { useState, useEffect } from "react";
// import List from "../../evaluation/evaluationList";
import Detail from "../reportDetail/reportDetail.view2";
// import List from "../reportList";

import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import Select from "react-select";
import {
  OrgChartHeader,
  BreadcrumbDiv,
  SelectYear,
} from "../../evaluation/evaluationManagerForm/evaluationManagerForm.styled";
import { DEPARTMENT_RRHH_COMUNICACION_SSGG, DEPARTMENTS } from "../../../../constants";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as ReportService from "../../../../services/ReportService";

const queryClient = new QueryClient();

const ReportResFinalFilterListContainer = (props) => {
  const { t } = useTranslation();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.report.title") },
  ];
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let index = 0; index < 5; index++) {
    years.push({
      value: currentYear - index,
      label: currentYear - index,
    });
  }

  const [year, setYear] = useState({ value: currentYear, label: currentYear });
  const [department, setDepartment] = useState({
    value: DEPARTMENT_RRHH_COMUNICACION_SSGG.code,
    label: t(DEPARTMENT_RRHH_COMUNICACION_SSGG.label),
  });
  const [data, setData] = useState(null);
  const [skills, setSkills] = useState(null);

  const loadData = async (filters) => {
    const result = await ReportService.filterOneReport(filters);
    setData(result?.data);
    setSkills(result?.skills);
  };

  useEffect(() => {
    const filters = {};
    if (year) {
      filters.year = year.value;
    }
    if (department) {
      filters.department = department.value;
    }
    if (year && department) {
      loadData(filters);
    }
  }, [year, department]);

  return (
    <>
      {/* <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.evaluation.title")}</h3>
        </div>
      </div> */}

      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <OrgChartHeader>
            <h3>{t("forms.report.title")}</h3>

            <BreadcrumbDiv>
              <Breadcrumb items={breads} />
            </BreadcrumbDiv>
            {/* <p>{t("forms.consult.orgChart.subtitle")}</p> */}
          </OrgChartHeader>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <SelectYear>
            <div className="row align-items-center">
              <div className="col-auto">
                <label style={{ margin: 0, fontWeight: "500" }}>
                  {t("forms.report.labels.department")}
                </label>
              </div>
              <div className="col-6">
                <Select
                  id="department"
                  name="department"
                  value={department}
                  options={DEPARTMENTS.map((item) => ({
                    value: item.code,
                    label: t(item.label),
                  }))}
                  onChange={(value) => {
                    setDepartment(value);
                  }}
                  classNamePrefix="dark"
                  placeholder=""
                />
              </div>

              <div className="col-auto">
                <label style={{ margin: 0, fontWeight: "500" }}>
                  {t("forms.evaluation.labels.year")}
                </label>
              </div>
              <div className="col-auto" style={{ width: "150px" }}>
                <Select
                  id="year"
                  name="year"
                  value={year}
                  onChange={(value) => {
                    setYear(value);
                  }}
                  options={years}
                  classNamePrefix="dark"
                  placeholder=""
                />
              </div>
            </div>
          </SelectYear>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          {data ? (
            <Detail className="marg-top-1rem" data={data} skills={skills} />
          ) : (
            <div className="text-center">{t("forms.report.noData")}</div>
          )}
        </div>
      </div>
    </>
  );
};

ReportResFinalFilterListContainer.propTypes = {};

export default ReportResFinalFilterListContainer;
